@if (footerComponent()) {
  @defer (on viewport; when treatmentChannelLogo() !== undefined) {
    <ng-content
      *ngComponentOutlet="
        footerComponent();
        inputs: {
          mainLogoAlternative: treatmentChannelLogo()?.mainLogoAlternative || undefined,
          mainLogoDropShadowEffect: treatmentChannelLogo()?.dropShadow || undefined
        }
      "
    />
  } @placeholder {
    <div></div>
  }
}
